import { Link } from 'react-router-dom';
import { sites } from '@/mocks/sites';

export default function FeaturedSites() {
  const featuredSites = sites.filter((s) => s.featured);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100" data-product-shop="">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              精选推荐网址
            </h2>
            <p className="text-sm text-foreground-500">
              经过团队严格筛选的高品质网站，值得收藏
            </p>
          </div>
          <Link
            to="/category/tools"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {featuredSites.map((site) => (
            <a
              key={site.id}
              href={site.url}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="group bg-background-50 rounded-lg p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-3">
                <span className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                  <span className="text-primary-600 font-bold text-sm font-heading">
                    {site.name.charAt(0)}
                  </span>
                </span>
                <div className="flex items-center gap-1">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-xs text-secondary-500"></i>
                  </span>
                  <span className="text-xs text-foreground-500">{site.rating}</span>
                </div>
              </div>

              <h3 className="text-sm font-semibold text-foreground-900 mb-2 font-heading whitespace-nowrap">
                {site.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                {site.description}
              </p>

              <div className="flex flex-wrap items-center gap-2">
                {site.tags.slice(0, 3).map((tag) => (
                  <span
                    key={tag}
                    className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/tools"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部推荐网址
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}